interface PDFHeaderProps {
    title: string;
  }
  
  /**
   * PDF Header Component
   * Reusable header for PDF pages with customizable title
   */
  const PDFHeader = ({ title }: PDFHeaderProps) => {
    return (
        <div className="bg-dark-secondary flex items-center py-6 px-8 pdf-grid-header">
        <h1 className="text-3xl font-heading font-medium text-gray-800">
          {title}
        </h1>
      </div>
    );
  };
  
  export default PDFHeader;
  